import React from 'react'
import PropTypes from 'prop-types'
import Button from 'components/Button'
import Link from 'components/Link'
import GA4 from 'utils/GA4'
import { useTheme } from 'styled-components'
import { Body16 } from 'components/Typography'
import MarkdownRenderer from 'components/MarkdownRenderer'
import { Spacing50 } from 'styles/sharedStyle'
import { fixAudiences } from '../../utils/audiences'
import {
  Copy,
  CtaRow,
  Headline,
  Inner,
  List,
  ListItem,
  Notice,
  Wrapper,
} from './BulletList.style'

const BulletList = ({
  audiences,
  ctaLabel,
  ctaUrl,
  headline,
  introCopy,
  list: { list },
  secondaryCopy,
  villageSlug,
}) => {
  const bullets = list && list.split(/\s*[,،]\s*/)
  const hasAudiences = !!audiences
  const {
    colors: { sagedarkToSandstone },
  } = useTheme()

  return (
    <>
      <Spacing50 />
      <Wrapper hasAudience={hasAudiences} className={fixAudiences(audiences)}>
        <Inner>
          <Headline>{headline}</Headline>
          {!!introCopy && (
            <Body16 as="div">
              <Copy as={MarkdownRenderer} html={introCopy} />
            </Body16>
          )}

          {!!bullets && (
            <List>
              {bullets.map((item, i) => (
                <ListItem key={`item-${i.toString()}`}>
                  <Body16 style={{ color: sagedarkToSandstone }}>{item}</Body16>
                </ListItem>
              ))}
            </List>
          )}

          {(!!ctaLabel || !!secondaryCopy) && (
            <CtaRow>
              {!!secondaryCopy && <Notice>{secondaryCopy}</Notice>}
              {!!ctaLabel && (
                <Button
                  className="cta"
                  as={Link}
                  level="secondary"
                  to={ctaUrl}
                  onClick={() =>
                    GA4('bullet_list_CTA', {
                      cta_label: ctaLabel,
                      village_name: villageSlug,
                    })
                  }>
                  {ctaLabel}
                </Button>
              )}
            </CtaRow>
          )}
        </Inner>
      </Wrapper>
      <Spacing50 />
    </>
  )
}

BulletList.propTypes = {
  audiences: PropTypes.string,
  ctaLabel: PropTypes.string,
  ctaUrl: PropTypes.string,
  headline: PropTypes.string.isRequired,
  introCopy: PropTypes.shape({
    childMarkdownRemark: PropTypes.shape({
      html: PropTypes.string,
    }),
  }),
  list: PropTypes.shape({
    list: PropTypes.string,
  }),
  secondaryCopy: PropTypes.string,
  villageSlug: PropTypes.string,
}

BulletList.defaultProps = {
  audiences: '',
  ctaLabel: '',
  ctaUrl: '',
  introCopy: {
    childMarkdownRemark: {
      html: '',
    },
  },
  list: {
    list: '',
  },
  secondaryCopy: '',
  villageSlug: '',
}

export default BulletList
